<template>
	<div class="wrapper">
		<b-container class="pb-4" style="background: #fff">
			<b-row></b-row>
			<b-row>
				<b-col class="pt-5" lg="5">
				<!-- 
					<div class="video">
						<iframe
							width="100%"
							:src="videoUrl"
							poster=""
							controls="controls"
							x5-video-player-fullscreen="false"
							allowfullscreen="false"
							ref="homeVideo"
						>
						</iframe>
					</div> 
				-->
					<div class="video">
						<video
							width="100%"
							controls="controls"
							preload="preload"
							poster=""
							x5-video-player-fullscreen="true"
							playsinline=""
							webkit-playsinline=""
							:src="videoUrl"

						>
							Your browser does not support the video tag.
						</video>
					</div>
				</b-col>
				<b-col class="pt-5" col lg="7">
                    <h1 class="mb-4 ">{{$t('lang.Notice')}}<router-link class="moreAnn" to="/news/list?tab=1&type=1">MORE +</router-link></h1>
                    <div  v-for="(item, index) in notice" :key="index" style="margin-bottom: 0.98rem; height: 1.78rem; overflow: hidden;">
                        <router-link class="notice" :to="'/detail/index?mode=notice&id='+ item.id">
                            <em class="dot">●</em><span>{{item.title}}</span>
                        </router-link>
                    </div>
                </b-col>
			</b-row>
		</b-container>
		<div style="background: #f6f4f5">
			<b-container>
				<homeLayout :dataList="characterList">
					<template v-slot:title>
						<div class="title">{{$t('lang.index2020')}}</div>
					</template>
				</homeLayout>
			</b-container>
		</div>
	</div>
</template>
<script>
import homeLayout from '@/components/homeLayout';
export default {
	components:{
		homeLayout
	},
	data() {
		return {
			videoUrl: '',
			notice: [
				// {
				// 	text:
				// 		'2020未来科学大奖周：百位顶尖科学家、商界领袖、行业大咖与你在“云端”相约',
				// 	link: '',
				// }
			],
			characterList: [],
		}
	},
	created() {
		this.getVideo()
		this.getNotice()
		this.getCharacter()
    },
	methods: {
		getVideo() {
			this.$api.homeVideo().then((res) => {
				this.videoUrl = res.data.videoUrl
			})
		},
		getNotice() {
			this.$api.noticeList({ limit: 5, page: 1 }).then((res) => {
				this.notice = res.data.records
			})
		},
		getCharacter() {
			this.$api
				.characterList({ type: 1, awardYear: 2020 })
				.then((res) => {
					this.characterList = res.data
				})
		},
	},
}
</script>
<style lang="scss" scoped>
// .video{
// 	height: 100%;
// }
iframe{
	// height: 107%;
	border: none;
}
.el-cascader--small {
	width: 140px;
}
.background-grey {
	background: #f6f4f5;
}
.imgWrap {
	opacity: 1;
	overflow: hidden;
	transform: rotate(0deg);
	border-radius: 20px;
}

.title {
	font-size: 1.4rem;
	text-align: center;
	padding-top: 2rem;
	color: #666666;
	font-weight: bold;
}
.imgWrap img {
	display: block;
	width: 100%;
	height: 100%;
	transition: all 0.8s ease-in-out;
	border: 1px solid transparent;
	box-sizing: content-box;
}
.imgWrap img:hover {
	transform: scale(1.05, 1.05);
	transition: transform 0.8s cubic-bezier(0.215, 0.61, 0.355, 1),
		opacity 0.36s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.notice {
	color: #666666;
	font-size: 1.2rem;
	overflow: hidden;
	cursor: pointer;
	text-decoration: none;
}

.dot {
	color: #dfb676;
	margin-right: 1rem;
}

.moreAnn {
	color: #dfb676;
	font-size: 1rem;
	font-weight: 100;
	float: right;
	cursor: pointer;
}
</style>
